import styled from "styled-components"

import {LocationMarker as DefaultLocationMarker} from "@irati-web/geolocation/src/components/GeoMap"
import {greys} from "@irati/ui/src/global/colors"

import InfoWindow from "../InfoWindow"

export const StyledMarker = styled(DefaultLocationMarker)`
  position: relative;
  width: 20px;
  height: 20px;
  border: 2px solid ${greys.white};

  ${({isActive}) => isActive && `
    width: 30px;
    height: 30px;
    border: 3px solid ${greys.white};
  `}

  ${({zIndex}) => `
    z-index: ${zIndex};
  `}
`

export const StyledInfoWindow = styled(InfoWindow)`
  position: absolute;
  top: 0;
  left: 0;
  ${({position}) => (position === "top") && `
    transform: translateX(calc(-50% + 10px)) translateY(calc(-100% - 30px));
  `}
  ${({position}) => (position === "right") && `
    transform: translateX(70px) translateY(calc(-50% + 10px));
  `}
  ${({position}) => (position === "bottom") && `
    transform: translateX(calc(-50% + 35px)) translateY(75px);
  `}
  ${({position}) => (position === "left") && `
    transform: translateX(calc(-100% - 30px)) translateY(calc(-50% + 30px));
  `}
  ${({zIndex}) => `
    z-index: ${zIndex + 1};
  `}
`

export const Container = styled.div`
  position: relative;
`
